import {
  Box,
  Button,
  Icon,
  SimpleGrid,
  Spinner,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { HeaderCard } from "../../../../components/headerCard";
import { RiArrowLeftSLine, RiBarcodeBoxLine } from "react-icons/ri";
import { useInvoce } from "../../../../service/invoceSerivce";
import { useEffect } from "react";
import { formatedMonthDay, statusUpdatePrice } from "../../../../utils/utils";

export function ListInvoice() {
  const { getInvoce, data, isLoading } = useInvoce();

  useEffect(() => {
    getInvoce();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box>
      <HeaderCard
        title="FATURAS"
        titleButton="Voltar"
        icon={RiArrowLeftSLine}
        link="/assinatura"
      />

      {isLoading && (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          height={500}
        >
          <Spinner
            color="green.600"
            emptyColor="white"
            thickness="4px"
            size="xl"
            h={100}
            w={100}
          />
        </Box>
      )}

      <SimpleGrid
        flex="1"
        gap="4"
        minChildWidth="320px"
        alignItems="flex-start"
        px={1}
        py={1}
      >
        {data.length > 0 && !isLoading && (
          <Box p="4" borderRadius={8} height={500}>
            <TableContainer>
              <Table variant="striped" colorScheme="gray" size="sm">
                <Thead>
                  <Tr bg="green.600" height="10">
                    <Th color="white" textAlign="center">
                      STATUS
                    </Th>
                    <Th color="white" textAlign="center">
                      DATA DE EMISSÃO
                    </Th>
                    <Th color="white" textAlign="center">
                      NÚMERO DA FATURA
                    </Th>
                    <Th color="white" textAlign="center">
                      PLANO
                    </Th>
                    <Th color="white" textAlign="center">
                      VALOR
                    </Th>
                    <Th color="white" textAlign="center">
                      DATA VENCIMENTO
                    </Th>
                    <Th color="white">DATA PAGAMENTO</Th>
                    <Th color="white" textAlign="center">
                      BOLETO
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {data.map((item, index) => (
                    <Tr key={index}>
                      <Td textAlign="center">
                        {statusUpdatePrice(item.status)}
                      </Td>
                      <Td textAlign="center">
                        {formatedMonthDay(item.acquisition_date)}
                      </Td>
                      <Td textAlign="center">ABC1245</Td>
                      <Td textAlign="center">{item.plan.name}</Td>
                      <Td textAlign="center">{item.price}</Td>
                      <Td textAlign="center">
                        {formatedMonthDay(item.acquisition_date)}
                      </Td>
                      <Td textAlign="center">
                        {formatedMonthDay(item.acquisition_date)}
                      </Td>
                      <Td textAlign="center" width="10">
                        <Button
                          size="sm"
                          fontSize="sm"
                          as="a"
                          target="_blank"
                          href={item.link_pay}
                        >
                          <Icon fontSize="16px" as={RiBarcodeBoxLine} />
                        </Button>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </Box>
        )}
      </SimpleGrid>
    </Box>
  );
}
